import CreateCustomerControl, {
  IProps as ICreateCustomerControlProps,
} from '@/ui/components/createCustomerControl/CreateCustomerControl';
import { Modal, ModalProps } from '@payaca/ambrosia';

import { FC } from 'react';

export interface IProps
  extends
    Omit<ModalProps, 'title'>,
    Omit<ICreateCustomerControlProps, 'isInModal' | 'onCancel'> {
  title?: string;
  isProcessing?: boolean;
}

const CreateCustomerModal: FC<IProps> = (props) => {
  const {
    onClose,
    onSubmit,
    isProcessing,
    initialFormState,
    title = 'Create customer',
    ...rest
  } = props;

  return (
    <Modal title={title} onClose={onClose} {...rest}>
      <CreateCustomerControl
        isInModal
        onCancel={onClose}
        isProcessing={isProcessing}
        onSubmit={onSubmit}
        initialFormState={initialFormState}
      />
    </Modal>
  );
};

export default CreateCustomerModal;
